
  <div
:id="vnodeId" ref="subGridWrapper" :class="classes" @click="onClick"
       @mouseenter="mouseOverAction" @mouseleave="mouseLeaveAction">
    <div :class="bgImageColor1" />
    <div :class="bgImageColor2" />

    <drag-items
      class="sub-drag-item"
      :exclude-item="['container']"
      :vnode-id="vnodeId"
      :view-mode="viewMode"
      widget-class="grid-stack-item-sub"
    />

    <img
      v-show="fbNode.children.length === 0 && !backgroundImgExist"
      class="img-fluid shadow-none img-radius-none"
      style="position: absolute; top: 0; left: 0; padding: 18px 10px"
      src="/img/box-container-placeholder-.svg"
      alt=""
    />
    <div class="w-100">
      <div
          :id="`${vnodeId}-sub-grid`"
          ref="gridRootWrapper" class="position-relative sub-grid-visual-box">
<!--        box-color="#c2bebe8f"-->
        <visual-box
            ref="vsBox"
            box-color="#333333"
            :grid-column="column"
            :grid-column-height="cellHeight"
            :grid-v-node-id="`${vnodeId}-sub-grid`"/>
        <div
            ref="nestedGridStackElement"
            :style="fontColorBG"
            class="grid-stack"
        >
          <template v-for="node in fbNode.children">
            <grid-item-v3
                :key="node.data.props.vnodeId"
                :fb-node="node"
                v-bind="node.data.props"
                @removeElement="removeNode"
                @duplicateElement="duplicateNode"
                @forceRemoveElement="forceRemoveNode"
            >
            </grid-item-v3>
          </template>
        </div>
      </div>
    </div>
  </div>
